import { createFileRoute } from "@tanstack/react-router";
import SecureNoteViewPage from "@/pages/SecureNoteViewPage";

export const Route = createFileRoute("/tools/secure-note/view/$id")({
  component: SecureNoteViewPage,
});
